import { cva } from 'class-variance-authority';
import { disabledState, focusRing, transitionBase, uiMarker } from './shared';

/**
 * STATUS PILL MENU
 *
 * A Badge that opens a menu of the statuses it could be. The pill keeps the
 * badge recipe for its colour and shape; this adds only what makes it a
 * control: a pointer, a focus ring, a dimmed disabled state, and a chevron
 * at the end so it reads as something to press rather than a label.
 *
 * The colour is the badge's, so a restyle of badges restyles this too.
 */
export const statusPillTriggerRecipe = cva([
  uiMarker,
  'group cursor-pointer',
  'hover:opacity-80 data-[state=open]:opacity-80',
  focusRing,
  disabledState,
  transitionBase,
]);

/** The chevron at the end of the pill, at the badge's icon size. */
export const statusPillChevronRecipe = cva([
  uiMarker,
  'shrink-0 opacity-70 transition-transform duration-fast',
  'group-data-[state=open]:rotate-180',
]);
